import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    ACCOUNT_ITEM_ADD: "ACCOUNT_ITEM_ADD",
    ACCOUNT_ITEM_CLEAR: "ACCOUNT_ITEM_CLEAR",
    ACCOUNT_ITEM_RESET: "ACCOUNT_ITEM_RESET",
    ACCOUNT_ITEM_SET: "ACCOUNT_ITEM_SET",
    ACCOUNT_ITEM_UPDATE: "ACCOUNT_ITEM_UPDATE",

    ACCOUNTS_CLEAR: "ACCOUNTS_CLEAR",

    ACCOUNTS_GET_FAILURE: "ACCOUNTS_GET_FAILURE",
    ACCOUNTS_GET_REQUEST: "ACCOUNTS_GET_REQUEST",
    ACCOUNTS_GET_SUCCESS: "ACCOUNTS_GET_SUCCESS",

    ACCOUNTS_DELETE_FAILURE: "ACCOUNTS_DELETE_FAILURE",
    ACCOUNTS_DELETE_REQUEST: "ACCOUNTS_DELETE_REQUEST",
    ACCOUNTS_DELETE_SUCCESS: "ACCOUNTS_DELETE_SUCCESS",

    ACCOUNTS_POST_FAILURE: "ACCOUNTS_POST_FAILURE",
    ACCOUNTS_POST_REQUEST: "ACCOUNTS_POST_REQUEST",
    ACCOUNTS_POST_SUCCESS: "ACCOUNTS_POST_SUCCESS",

    ACCOUNTS_MERGE: "ACCOUNTS_MERGE",
    ACCOUNTS_SET: "ACCOUNTS_SET"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.ACCOUNTS_CLEAR
    }),

    getRequest: () => ({
        type: actionTypes.ACCOUNTS_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ACCOUNTS_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.ACCOUNTS_GET_FAILURE
    }),
    getSuccess: (accounts: any) => ({
        type: actionTypes.ACCOUNTS_GET_SUCCESS,
        payload: { accounts }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.ACCOUNTS_GET_FAILURE,
        error
    }),

    deleteRequest: (account) => ({
        type: actionTypes.ACCOUNTS_DELETE_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ACCOUNTS_DELETE_SUCCESS,
        [ERROR_ACTION]: actionTypes.ACCOUNTS_DELETE_FAILURE,
        payload: { account }
    }),
    deleteSuccess: () => ({
        type: actionTypes.ACCOUNTS_DELETE_SUCCESS
    }),
    deleteFailure: (error: Error) => ({
        type: actionTypes.ACCOUNTS_DELETE_FAILURE,
        error
    }),

    itemAdd: () => ({
        type: actionTypes.ACCOUNT_ITEM_ADD
    }),
    itemClear: () => ({
        type: actionTypes.ACCOUNT_ITEM_CLEAR
    }),
    itemReset: () => ({
        type: actionTypes.ACCOUNT_ITEM_RESET
    }),
    itemSet: (account: any) => ({
        type: actionTypes.ACCOUNT_ITEM_SET,
        payload: { account }
    }),
    itemUpdate: (account: any) => ({
        type: actionTypes.ACCOUNT_ITEM_UPDATE,
        payload: { account }
    }),

    postRequest: (accounts: Array<any>) => ({
        type: actionTypes.ACCOUNTS_POST_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ACCOUNTS_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.ACCOUNTS_POST_FAILURE,
        payload: { accounts }
    }),
    postSuccess: (accounts: Array<any>) => ({
        type: actionTypes.ACCOUNTS_POST_SUCCESS,
        payload: { accounts }
    }),
    postFailure: (error: Error) => ({
        type: actionTypes.ACCOUNTS_POST_FAILURE,
        error
    }),

    merge: (accounts: Array<any>) => ({
        type: actionTypes.ACCOUNTS_MERGE,
        payload: { accounts }
    }),
    set: (accounts: Array<any>) => ({
        type: actionTypes.ACCOUNTS_SET,
        payload: { accounts }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
